import React, { useState } from 'react';


const SortSelect = ({ onSetOrderBy, discountShow = true }) => {
    const [selectedVal, setSelectedVal] = useState("");

    const options = [
        { value: "", label: "مرتب سازی" },
        { value: "cheap", label: "ارزانترین" },
        { value: "exp", label: "گرانترین" },
        { value: "new", label: "جدیدترین" },
        { value: "old", label: "قدیمی ترین" },
        ...(discountShow ? [{ value: "discount", label: "پرتخفیف ترین" }] : [])
    ];

    const currentLabel = options.find(o => o.value === selectedVal)?.label || "مرتب سازی";

    const handleChange = (e) => {
        const val = e.target.value;


        setSelectedVal(val);

        onSetOrderBy(val);
    };

    return (

            <div className="custom-sort-select w-100 mx-auto">
                <div className="select-visual">
                    <span className="label text-small-1">{currentLabel}</span>
                    <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-down-up icon" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                    </svg>
                </div>

                <select
                    className="real-select"
                    onChange={handleChange} // متصل به تابع هندلر بالا
                    value={selectedVal}
                >
                    {options.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </div>

    );
};

export default SortSelect;
